import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import myImg from "../../Assets/developer.jpg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { IoLogoReact } from "react-icons/io5";
import { SiNextdotjs, SiTailwindcss } from "react-icons/si";
import { FaNodeJs } from "react-icons/fa6";
import { SiExpress } from "react-icons/si";
import { GrDocker, GrMysql } from "react-icons/gr";
import { SiPostgresql } from "react-icons/si";
import { BiLogoMongodb } from "react-icons/bi";
import { TbApi } from "react-icons/tb";
import { GoDatabase } from "react-icons/go";
import { FaRegLightbulb } from "react-icons/fa";
import { IoSettingsOutline } from "react-icons/io5";
import { DiResponsive } from "react-icons/di";
import { LuGitFork } from "react-icons/lu";
import { SiAdguard } from "react-icons/si";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <h1 className="services-heading">Services I Provide</h1>
          <Col md={7} className="home-about-description">
            <h3 className="home-about-body">
              I'm a dedicated full-stack web developer with a hands-on
              experience on crafting websites with responsive UI's and optimized
              backend codes. <br />
              <span className="expertise-title">
                Here are my areas of expertise:{" "}
              </span>
              <div className="flex-container">
                <div style={{ marginLeft: "20px" }} className="expertise-area">
                  <p className="flex-item items">
                    <SiNextdotjs
                      style={{
                        marginRight: "8px",
                        marginBottom: "2.3px",
                      }}
                    />
                    Next.js
                  </p>
                  <p className="flex-item items">
                    <IoLogoReact
                      style={{ marginRight: "8px", marginBottom: "2.3px" }}
                    />
                    ReactJS{" "}
                  </p>
                  <p className="flex-item items">
                    <SiTailwindcss
                      style={{ marginRight: "8px", marginBottom: "2.3px" }}
                    />
                    TailwindCSS
                  </p>
                  <p className="flex-item items">
                    <FaNodeJs
                      style={{ marginRight: "8px", marginBottom: "2.3px" }}
                    />
                    NodeJS{" "}
                  </p>
                  <p className="flex-item items">
                    <SiExpress
                      style={{ marginRight: "8px", marginBottom: "2.3px" }}
                    />
                    ExpressJS{" "}
                  </p>
                </div>
                <div style={{ marginLeft: "20px" }} className="flex-item">
                  <p className="flex-item items">
                    <GrDocker
                      style={{ marginRight: "8px", marginBottom: "2.3px" }}
                    />
                    Docker{" "}
                  </p>
                  <p className="flex-item items">
                    <GrMysql
                      style={{ marginRight: "8px", marginBottom: "2.3px" }}
                    />
                    SQL{" "}
                  </p>
                  <p className="flex-item items">
                    <SiPostgresql
                      style={{ marginRight: "8px", marginBottom: "2.3px" }}
                    />
                    PostgreSQL{" "}
                  </p>
                  <p className="flex-item">
                    <BiLogoMongodb
                      style={{ marginRight: "8px", marginBottom: "2.3px" }}
                    />
                    MongoDB{" "}
                  </p>
                </div>
              </div>
              <span className="expertise-title">
                And here are my key strengths:
              </span>
              <div style={{ marginLeft: "20px" }}>
                <p className="items">
                  {" "}
                  <TbApi
                    className="flex-item"
                    style={{ marginRight: "8px", marginBottom: "2.3px" }}
                  />
                  REST API's{" "}
                </p>
                <p className="items">
                  {" "}
                  <GoDatabase
                    className="flex-item"
                    style={{ marginRight: "8px", marginBottom: "2.5px" }}
                  />
                  Optimized SQL and NoSQL databases
                </p>
                <p className="items">
                  {" "}
                  <IoSettingsOutline
                    className="flex-item"
                    style={{ marginRight: "8px", marginBottom: "2.3px" }}
                  />
                  State management
                </p>
                <p className="items">
                  {" "}
                  <DiResponsive
                    className="flex-item"
                    style={{ marginRight: "8px", marginBottom: "2.3px" }}
                  />
                  Responsive UI's
                </p>
                <p className="items">
                  {" "}
                  <LuGitFork
                    className="flex-item"
                    style={{ marginRight: "8px", marginBottom: "2.3px" }}
                  />
                  Version control
                </p>
                <p className="items">
                  {" "}
                  <FaRegLightbulb
                    className="flex-item"
                    style={{ marginRight: "8px", marginBottom: "2.5px" }}
                  />
                  Strategic problem solver
                </p>
                <p className="flex-item">
                  {" "}
                  <SiAdguard
                    style={{ marginRight: "8px", marginBottom: "2.3px" }}
                  />{" "}
                  100% work quality assurance
                </p>
              </div>
              {/* I'm <span className="flex-item">open</span> for discussion on making valuable technical solutions for your ideas. */}
            </h3>
          </Col>
          <Col md={5} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="flex-item">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/fitiha"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/natnael-fisseha/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/edilfish/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
